import { render } from "./CustomRadioButton.vue?vue&type=template&id=0135c0b5&scoped=true&ts=true"
import script from "./CustomRadioButton.vue?vue&type=script&lang=ts"
export * from "./CustomRadioButton.vue?vue&type=script&lang=ts"

import "./CustomRadioButton.vue?vue&type=style&index=0&id=0135c0b5&lang=scss&scoped=true"

import exportComponent from "/home/kenddriz/Public/locaa/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0135c0b5"]])

export default __exports__